module.exports = __webpack_public_path__ + "img/skip4_g.6cabf641.svg";